import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Loader2, Send } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const DigestCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/digest/preview").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const sendNow = async () => {
    if (!window.confirm("Send this month's usage digest to all super admin emails now?")) return;
    setBusy(true);
    try {
      const res = await api.post("/admin/digest/send", { base_url: window.location.origin });
      if (res.data.sent) toast.success(`Digest sent to ${res.data.sent} recipient${res.data.sent === 1 ? "" : "s"}`);
      if (res.data.failed) toast.warning(`${res.data.failed} could not be delivered: ${res.data.errors[0]}`, { duration: 9000 });
      load();
    } catch (e) { toast.error("Could not send digest"); }
    finally { setBusy(false); }
  };

  if (!d) return null;
  const t = d.totals;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 flex flex-wrap items-center gap-6" data-testid="digest-card">
      <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center shrink-0"><CalendarClock className="w-6 h-6 text-indigo-600" /></div>
      <div className="flex-1 min-w-[220px]">
        <h2 className="font-heading font-bold text-lg text-slate-900">Monthly usage digest</h2>
        <p className="font-body text-sm text-slate-500 mt-0.5">
          Emailed automatically on the 1st of every month to all super admins.
          {d.last_scheduled?.sent_at ? ` Last sent ${new Date(d.last_scheduled.sent_at).toLocaleDateString()}.` : " No scheduled digest sent yet."}
        </p>
        <p className="font-body text-xs text-slate-500 mt-2" data-testid="digest-preview">
          <span className="font-semibold text-slate-700">{d.period} so far:</span> {t.generated} codes generated · {t.completed} reports completed · {t.credits_outstanding} credits outstanding
        </p>
      </div>
      <Button variant="outline" onClick={sendNow} disabled={busy} className="rounded-xl font-heading font-bold" data-testid="digest-send-btn">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Send className="w-4 h-4 mr-1" />} Send digest now
      </Button>
    </div>
  );
};
